var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-item__badge",style:((_vm.badge.action || _vm.badge.hint) ? {
                    pointerEvents: 'all',
                    cursor: 'help',
                } : null),on:{"click":function($event){_vm.badge.action ? _vm.$emit('action', _vm.badge.action) : null}}},[_c('icon',{attrs:{"name":'badge-' + _vm.badge.icon,"height":"1em","width":"auto","original":""}}),(_vm.badge.hint)?_c('div',{staticClass:"page-item__badge-hint",domProps:{"textContent":_vm._s(_vm.badge.hint)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }